import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaUserTie, FaUsers, FaIndustry, FaUniversity } from "react-icons/fa";
import "./Specialties.scss";

const specialties = [
  {
    icon: <FaUserTie className="icon" />,
    title: "Compliance y responsabilidad penal de empresas",
    description:
      "Implementación de modelos de prevención de delitos y buenas prácticas corporativas, adaptados a las exigencias legales nacionales e internacionales.",
  },
  {
    icon: <FaUsers className="icon" />,
    title: "Derecho laboral y gestión de personas",
    description:
      "Asesoría estratégica en relaciones laborales, contratos, desvinculaciones, negociaciones colectivas y prevención de conflictos con trabajadores y sindicatos.",
  },
  {
    icon: <FaIndustry className="icon" />,
    title: "Derecho tributario y planificación fiscal",
    description:
      "Análisis de cumplimiento de la normativa tributaria y defensa en procedimientos ante el SII y TTA. ",
  },
  {
    icon: <FaIndustry className="icon" />,
    title: "Contratación y negociación comercial",
    description:
      "Redacción, revisión y negociación de contratos comerciales nacionales e internacionales, con foco en proteger el interés del cliente y evitar futuros litigios.",
  },
  {
    icon: <FaUniversity className="icon" />,
    title: "Propiedad intelectual y nuevas tecnologías",
    description:
      "Protección de creaciones, marcas y activos intangibles. Asesoría legal para industrias creativas y empresas tecnológicas.",
  },
  {
    icon: <FaUniversity className="icon" />,
    title: "Protección de creaciones, marcas y activos intangibles. Asesoría legal para industrias creativas y empresas tecnológicas.",
    description:
      "Asesoría en cumplimiento normativo ambiental, Ley General de Urbanismo y Construcciones y procesos de evaluación estratégica para proyectos de inversión.",
  },
  {
    icon: <FaUsers className="icon" />,
    title: "Derecho Civil y contratos",
    description:
      "Asesoría en redacción, revisión y negociación de escrituras y tramitación de juicios civiles.",
  },
];

const Specialties = () => {
  return (
    <Container className="specialties-section">
            <div md={12} className="front-title">
                <h2 className="section-title">Algunas de nuestras especialidades</h2>
                <p className="section-description">
                    Nuestro estudio jurídico está calificado para brindar asesoría legal y judicial en diversas áreas del derecho. Su oferta se extiende por:
                </p>
            </div>
            <Row md={12}>
            {specialties.map((specialty) => (
                <Col lg={6} md={6} sm={12}>
                    <div md={6} className="specialty-card">
                        <div>
                            {specialty.icon}  
                        </div>
                        <div>
                            <h4>{specialty.title}</h4>
                        </div>
                        <div>
                            <p>{specialty.description}</p>
                        </div>
                    </div>
                </Col>
            ))}
            </Row>
    </Container>
  );
};

export default Specialties;
